import React from "react";
import VendorDashboardPage from "../component/VendorDashboardPage";

const VendorDashboard = () => (
  <div>
    <VendorDashboardPage />
  </div>
);

export default VendorDashboard;
